import { DefaultTheme } from '../theme';

export const CSS = {
	container: 'c-Input',
	wrapper: 'c-Input__wrapper',
	input: 'c-Input__input',
	label: 'c-Input__label',

	button: 'c-Input__button',
	error: 'c-input__error',

	isFullWidth: 'c-input--full-width',
	isCompact: 'c-input--is-compact',
	isFocused: 'c-Input--is-focused',
	isDirty: 'c-Input--is-dirty',
	isDisabled: 'c-input--is-disabled',
	isInvalid: 'c-input--is-invalid',

	MDL: {
		container: 'mdl-textfield mdl-textfield--floating-label',
		floatingLabel: 'mdl-textfield--floating-label',
		error: 'mdl-textfield__error',
		label: 'mdl-textfield__label',
		input: 'mdl-textfield__input',
		isFocused: 'is-focused',
		isDirty: 'is-dirty',
		isUpgraded: 'is-upgraded',
		isInvalid: 'is-invalid',
	},
};

export const Style = {
	[CSS.container]: {
		width: '100%',
	},
	[`${CSS.container} .mdl-button`]: {
		right: 0,
		color: DefaultTheme.font.color.supporting,
	},
	[`${CSS.input}::-ms-clear`]: {
		// Hide clear button on input element for IE
		display: 'none',
	},
	[CSS.wrapper]: {
		width: '100%',
		position: 'relative',
	},
	[CSS.error]: {
		visibility: 'visible',
		position: 'relative',
		'margin-top': '-17px',
	},
	[`${CSS.isCompact} ~ .${CSS.error}`]: {
		'margin-top': '3px',
	},
	[CSS.isCompact]: {
		padding: 0,
	},
	[`${CSS.isCompact} input`]: {
		outline: 'none',
		'font-family': 'Roboto Condensed',
		'font-size': '14px',
		padding: 0,
	},
	[`${CSS.isCompact} textarea`]: {
		outline: 'none',
		'font-family': 'Roboto Condensed',
		'font-size': '14px',
		padding: 0,
	},
	[`${CSS.isCompact} .mdl-textfield__label:after`]: {
		bottom: '0px',
	},
};
